/* 🤖 this file was generated by svg-to-ts */
export const sbIconsCalendarGroup: {
  name: 'calendar-group';
  data: string;
} = {
  name: 'calendar-group',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22"><path fill="currentColor" d="M17 2h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1H6V1c0-.55-.45-1-1-1S4 .45 4 1v1H3C1.34 2 0 3.34 0 5v14c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3m1 17c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-9h16zm0-11H2V5c0-.55.45-1 1-1h1v1c0 .55.45 1 1 1s1-.45 1-1V4h8v1c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1 .45 1 1zM5 12h10c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1m0 4h10c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1"/></svg>`
};
